import React from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';
import { X } from 'lucide-react';

const StyledOverlay = styled.div`
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  opacity: 0;
  transition: opacity 200ms ease-in-out;

  &[class*='--after-open'] {
    opacity: 1;
  }

  &[class*='--before-close'] {
    opacity: 0;
  }

  a {
    color: ${p => p.theme.colors.deepBlue};
  }
`;

const StyledModal = styled.div`
  width: 80%;
  background: ${p => p.theme.colors.white};
  padding: ${p => p.theme.spacing.lg};
  border-radius: 12px;
  max-width: 900px;
  position: relative;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.07),
    0 10px 15px rgba(0, 0, 0, 0.1),
    0 20px 25px rgba(0, 0, 0, 0.08);
  overflow: auto;
`;
const StyledCloseButton = styled.button`
  appearance: none;
  background-color: ${p => p.theme.colors.lightGrey};
  border: 1px solid ${p => p.theme.colors.border};
  color: ${p => p.theme.colors.black};
  transition: all 0.2s;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  position: absolute;
  right: ${p => p.theme.spacing.lg};
  top: ${p => p.theme.spacing.lg};

  &:hover,
  &:focus {
    background-color: ${p => p.theme.colors.grey};
  }
`;

interface Props {
  isOpen: boolean;
  onClose?: Function;
  children: any;
  ariaLabelledBy?: string;
}

const Modal = (props: Props) => {
  const close = () => {
    if (props.onClose) props.onClose();
  };

  return (
    <ReactModal
      isOpen={props.isOpen}
      onRequestClose={() => close()}
      closeTimeoutMS={200}
      shouldFocusAfterRender
      shouldReturnFocusAfterClose
      aria={
        props.ariaLabelledBy ? { labelledby: props.ariaLabelledBy } : undefined
      }
      className="_"
      overlayClassName="_"
      contentElement={(contentProps, children) => (
        <StyledModal {...contentProps}>{children}</StyledModal>
      )}
      overlayElement={(overlayProps, contentElement) => (
        <StyledOverlay {...overlayProps}>{contentElement}</StyledOverlay>
      )}
    >
      <StyledCloseButton aria-label="Close" onClick={() => close()}>
        <X size={16} aria-hidden={true} />
      </StyledCloseButton>
      {props.children}
    </ReactModal>
  );
};

export { Modal };
